import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Coupon from "../Coupon.vue";
import Lianbao from "./Lianbao.vue";
import CourseShowService from "./CourseShowService.vue";
import CourseShowValid from "./CourseShowValid.vue";
import CourseShowBuy from "./CourseShowBuy.vue";
import CourseShowPrice from "./CourseShowPrice.vue";
import CourseClass from "./CourseClass.vue";
import CourseTimeRange from "./CourseTimeRange.vue";
import CourseShowTabs from "./CourseShowTabs.vue";
export default {
  name: "RichCourseShow",
  components: {
    Coupon: Coupon,
    Lianbao: Lianbao,
    CourseShowService: CourseShowService,
    CourseShowValid: CourseShowValid,
    CourseShowBuy: CourseShowBuy,
    CourseShowPrice: CourseShowPrice,
    CourseClass: CourseClass,
    CourseTimeRange: CourseTimeRange,
    CourseShowTabs: CourseShowTabs
  },
  props: {
    course: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    has_buy: {
      type: Boolean,
      default: false
    },
    couponList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    teachers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    teaching: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    courses: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    recommendCourses: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    discountList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    discountCourseList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    exam: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    course: function course() {
      var _this = this;

      this.$nextTick(function () {
        _this.removeImageTitle();
      });
    }
  },
  computed: {
    isValid: function isValid() {
      return this.$services.CourseService.checkBuyValid(this.course);
    },
    // 会员引导内容
    vip_guide: function vip_guide() {
      if (!this.course.vipData.firstVip.id) return "";
      var user_info = this.$store.state.user_info;
      var guide = "\u5F00\u901A".concat(this.course.vipData.firstVip.name, "\u5373\u53EF\u514D\u8D39\u62A5\u540D\u8BE5\u8BFE\u7A0B");

      if (this.getIsExpire) {
        return guide;
      } //用户是会员


      if (this.$store.state.token && user_info.vip_info.vip_id) {
        if (this.course.vipData.is_vip_course == 1) {
          guide = "\u60A8\u5DF2\u662F".concat(user_info.vip_info.name, "\uFF0C\u53EF\u4EE5\u514D\u8D39\u5B66\u4E60\u8BE5\u8BFE\u7A0B\uFF0C\u5FEB\u53BB\u62A5\u540D\u5427");
        } else {
          guide = "\u60A8\u662F".concat(user_info.vip_info.name, "\uFF0C\u4E0D\u80FD\u514D\u8D39\u5B66\u4E60\u8BE5\u8BFE\u7A0B\uFF0C\u5982\u6709\u7591\u95EE\u8BF7\u54A8\u8BE2\u5BA2\u670D");
        }
      }

      return guide;
    },
    isShowOpenVip: function isShowOpenVip() {
      if (!this.$store.state.token || this.getIsExpire || this.$store.state.user_info.vip_info && !this.$store.state.user_info.vip_info.vip_id) {
        return true;
      } else {
        return false;
      }
    },
    //判断会员是否过期
    getIsExpire: function getIsExpire() {
      if (this.course.userVipData.end_at) {
        var now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳

        if (now > this.course.userVipData.end_at) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }

      return false;
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.removeImageTitle();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    removeImageTitle: function removeImageTitle() {
      var courseDetail = document.getElementById("course-detail");

      if (!courseDetail) {
        return;
      }

      courseDetail.querySelectorAll("img").forEach(function (ele) {
        ele.removeAttribute("title");
      });
    },
    onShareClick: function onShareClick() {
      this.$emit("shareClick");
    },
    goToStudy: function goToStudy() {
      this.$emit("goToStudy");
    },
    buy: function buy() {
      this.$emit("buy");
    },
    getCoupon: function getCoupon(id) {
      this.$emit("getCoupon", id);
    },
    openVip: function openVip() {
      this.$emit("openVip");
    },
    vipFree: function vipFree() {
      this.$emit("vipFree");
    }
  }
};